import { merge } from '../../../helper';

// ----------------------------------------------------------------------------

function searchOptions(
    element: HTMLSelectElement,
    find: string,
    config: Record<string, any> = {},
): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        type: 'text', // 'value' or 'text'
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    const found: any[] = [];
    const notFound: any[] = [];

    // Foreach Options
    for (const elOption of element.options) {
        // If the match is found
        if (elOption[defConfig.type].match(find)) {
            // If using function found
            if (typeof defConfig.fnFound === 'function') {
                defConfig.fnFound(elOption);
            }

            // Found Push
            found.push(elOption);
        }
        // If the match is not found
        else {
            // If using function not found
            if (typeof defConfig.fnNotFound === 'function') {
                defConfig.fnNotFound(elOption);
            }

            // Not Found Push
            notFound.push(elOption);
        }
    }

    return {
        found,
        notFound,
    };
}

// ----------------------------------------------------------------------------

export default searchOptions;
